import { render, staticRenderFns } from "./BOQDetails.vue?vue&type=template&id=51a6b100&scoped=true"
import script from "./BOQDetails.vue?vue&type=script&lang=js"
export * from "./BOQDetails.vue?vue&type=script&lang=js"
import style0 from "./BOQDetails.vue?vue&type=style&index=0&id=51a6b100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a6b100",
  null
  
)

export default component.exports